__turbopack_context__.v({
  "dialog-enter": "Dialog-module__Xp-e4a__dialog-enter",
  "dialog-enter-active": "Dialog-module__Xp-e4a__dialog-enter-active",
  "dialog-exit": "Dialog-module__Xp-e4a__dialog-exit",
  "dialog-exit-active": "Dialog-module__Xp-e4a__dialog-exit-active",
});
